import { PROFILE_SERVICE_BASE_URL, serviceFetch } from './mobileParityApi';

export const MOBILE_SUPPORT_SOURCE_APP = 'olitask-mobile-ui' as const;

export type HelpRequestCategory =
  | 'General Inquiry'
  | 'Technical Support'
  | 'Billing Issue'
  | 'Feedback'
  | 'Account Help'
  | 'Other';

export type HelpRequestPayload = {
  category: HelpRequestCategory;
  message: string;
  sourceApp: typeof MOBILE_SUPPORT_SOURCE_APP;
};

export type FeedbackSubject =
  | 'GENERAL_FEEDBACK'
  | 'PERFORMANCE'
  | 'APP_BUG'
  | 'FEATURE_REQUEST'
  | 'UI_FEEDBACK'
  | 'PAYMENTS'
  | 'TASKS'
  | 'SAFETY'
  | 'HARASSMENT'
  | 'ACCOUNT'
  | 'VERIFICATION'
  | 'SUPPORT'
  | 'OTHER';

export type Feeling = 'LIKE' | 'DISLIKE' | 'HAPPY' | 'SAD';

export type FeedbackPayload = {
  subject: FeedbackSubject;
  subjectId?: string;
  feeling?: Feeling;
  content: string;
  attachments?: string[];
};

export async function sendHelpRequest(
  payload: HelpRequestPayload,
  actorId?: string
): Promise<void> {
  await serviceFetch(
    `${PROFILE_SERVICE_BASE_URL}/api/v1/help`,
    {
      method: 'POST',
      actorId,
      body: JSON.stringify({
        category: payload.category,
        message: payload.message,
        sourceApp: MOBILE_SUPPORT_SOURCE_APP,
      }),
    },
    'Failed to send help request'
  );
}

export async function sendFeedback(
  payload: FeedbackPayload,
  actorId?: string
): Promise<void> {
  const body: FeedbackPayload = {
    subject: payload.subject,
    subjectId: payload.subjectId ?? '',
    feeling: payload.feeling,
    content: payload.content,
    ...(payload.attachments?.length ? { attachments: payload.attachments } : {}),
  };

  await serviceFetch(
    `${PROFILE_SERVICE_BASE_URL}/api/v1/feedback`,
    {
      method: 'POST',
      actorId,
      body: JSON.stringify(body),
    },
    'Failed to send feedback'
  );
}
